import React, { useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';

import ExandableGrid from '@prisjakt/ui-expandable-grid';
import { plainText } from '../../../../../editorial-content/components/slices/rich-text';

import * as S from './styles';

import { PrismicArticle } from '../../../../../../types';

type Props = {
  nodes: PrismicArticle[];
};

export default function Articles({ nodes }: Props) {
  const { t } = useContext(AppContext);

  return (
    <S.Articles>
      <ExandableGrid
        expandText={t('common', 'button.show-more')}
        collapseText={t('common', 'button.show-less')}
        limit={4}
        items={nodes.map(article => (
          <S.Article
            key={article.id}
            imageUrl={article.data.featuredImage?.url}
            pathName={article.pathName}
            title={plainText(article.data.title)}
            preamble={plainText(article.data.metaDescription)}
            linkText={t('landing', 'featured-article.read-more')}
          />
        ))}
      />
    </S.Articles>
  );
}
